import { Token } from './fetchToken';

let currentToken: Token | null = null;

const getScopeCurrentToken = () => currentToken;
const setScopeCurrentToken = (newToken: Token | null) => {
  currentToken = newToken;
};

export const getCachedCurrentToken = () => {
  return getScopeCurrentToken();
};

export const setCachedCurrentToken = (newToken: Token) => {
  setScopeCurrentToken(newToken);
};

export const clearCachedCurrentToken = () => {
  setScopeCurrentToken(null);
};
